<section class="header">
    <nlr-header></nlr-header>
</section>
@if (['EXTRACT_CADASTRE'] | hasPermissions) {
    <div class="container-fluid">
        <h4>Extract Cadastre</h4>
        <div class="parcel-search row">
            <div class="col-xs-12">
                <h5>Parcel search</h5>
            </div>
            <div class="col-md-3 col-xs-6">
                <label
                    class="control-label"
                    for="parcelIdentifier">
                    Parcel identifier
                </label>
                <div class="input-group">
                    <input
                        type="text"
                        id="parcelIdentifier"
                        name="parcelIdentifier"
                        class="form-control"
                        placeholder="e.g. 12/SP1234"
                        autocomplete="off"
                        [nlrPattern]="parcelPattern"
                        [(ngModel)]="parcelIdentifier"
                        (keyup.enter)="searchByParcelIdentifier()"
                        nlrUppercase
                        #parcelIdentifierInput="ngModel" />
                    <span class="input-group-addon">
                        <button
                            type="button"
                            class="btn"
                            title="Search"
                            [disabled]="searchByParcelIdentifierDisabled()"
                            (click)="searchByParcelIdentifier()">
                            <i class="nlrp-icon nlrp-icon-search"></i>
                        </button>
                    </span>
                </div>
                @if (parcelIdentifierInput | formFieldHasError) {
                    <div class="help-block">
                        <span>Error!</span>
                        <span>Invalid</span>
                    </div>
                }
            </div>
            <div class="col-md-3 col-xs-6">
                <label
                    class="control-label"
                    for="landIdentifier">
                    Land identifier
                </label>
                <div class="input-group">
                    <input
                        type="text"
                        id="landIdentifier"
                        name="landIdentifier"
                        class="form-control"
                        placeholder="e.g. from 0 to 999999999"
                        autocomplete="off"
                        [nlrPattern]="landPattern"
                        [(ngModel)]="landIdentifier"
                        (keyup.enter)="searchByLandIdentifier()"
                        #landIdentifierInput="ngModel" />
                    <span class="input-group-addon">
                        <button
                            type="button"
                            class="btn"
                            title="Search"
                            [disabled]="searchByLandIdentifierDisabled()"
                            (click)="searchByLandIdentifier()">
                            <i class="nlrp-icon nlrp-icon-search"></i>
                        </button>
                    </span>
                </div>
                @if (landIdentifierInput | formFieldHasError) {
                    <div class="help-block">
                        <span>Error!</span>
                        <span>Invalid</span>
                    </div>
                }
            </div>
            <div class="col-md-3 col-xs-6">
                <label
                    class="control-label"
                    for="titleIdentifier">
                    Title identifier
                </label>
                <div class="input-group">
                    <input
                        type="text"
                        id="titleIdentifier"
                        name="titleIdentifier"
                        class="form-control"
                        placeholder="e.g. 1234-567"
                        autocomplete="off"
                        [nlrPattern]="titlePattern"
                        [(ngModel)]="titleIdentifier"
                        (keyup.enter)="searchByTitleIdentifier()"
                        nlrUppercase
                        #titleIdentifierInput="ngModel" />
                    <span class="input-group-addon">
                        <button
                            type="button"
                            class="btn"
                            title="Search"
                            [disabled]="searchByTitleIdentifierDisabled()"
                            (click)="searchByTitleIdentifier()">
                            <i class="nlrp-icon nlrp-icon-search"></i>
                        </button>
                    </span>
                </div>
                @if (titleIdentifierInput | formFieldHasError) {
                    <div class="help-block">
                        <span>Error!</span>
                        <span>Invalid</span>
                    </div>
                }
            </div>
            <div class="col-md-3 col-xs-6">
                <label
                    class="control-label"
                    for="planIdentifier">
                    Plan identifier
                </label>
                <div class="input-group">
                    <input
                        type="text"
                        id="planIdentifier"
                        name="planIdentifier"
                        class="form-control"
                        placeholder="e.g. DP1234"
                        autocomplete="off"
                        [nlrPattern]="surveyPattern"
                        [(ngModel)]="planIdentifier"
                        (keyup.enter)="searchByPlanIdentifier()"
                        nlrUppercase
                        #planIdentifierInput="ngModel" />
                    <span class="input-group-addon">
                        <button
                            type="button"
                            class="btn"
                            title="Search"
                            [disabled]="searchByPlanIdentifierDisabled()"
                            (click)="searchByPlanIdentifier()">
                            <i class="nlrp-icon nlrp-icon-search"></i>
                        </button>
                    </span>
                </div>
                @if (planIdentifierInput | formFieldHasError) {
                    <div class="help-block">
                        <span>Error!</span>
                        <span>Invalid</span>
                    </div>
                }
            </div>
            @if (parcelSearchErrorMessage) {
                <div class="col-xs-12">
                    <div class="help-block">
                        <span>Error!</span>
                        <span id="parcelSearchErrorMessage">{{parcelSearchErrorMessage}}</span>
                    </div>
                </div>
            }
        </div>
        @if (parcelSearchResults?.length) {
            <div class="row">
                <div class="col-xs-12">
                    <div>
                        @if (parcelSearchResults.length > MAX_PARCEL_SELECTION_COUNT) {
                            Select parcels (maximum {{MAX_PARCEL_SELECTION_COUNT}}):
                        } @else {
                            Select parcels:
                        }
                    </div>
                </div>
            </div>
            <div class="parcel-search-results row">
                <div class="col-xs-12">
                    <table class="table table-striped">
                        <thead>
                            <tr class="default">
                                <th>&nbsp;</th>
                                <th>Name</th>
                                <th>Alternative land name</th>
                                <th>Land type</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            @for (parcelSearchResult of parcelSearchResults; track $index) {
                                <tr>
                                    <td>
                                        <div class="nlr-checkbox">
                                            <input
                                                [attr.id]="'parcelSearchResultSelector' + $index"
                                                [name]="'parcelSearchResultSelector' + $index"
                                                type="checkbox"
                                                tabindex="-1"
                                                [(ngModel)]="parcelSearchResult.selected"
                                                [disabled]="isParcelSelectionDisabled(parcelSearchResult)" />
                                            <label [for]="'parcelSearchResultSelector' + $index">&nbsp;</label>
                                        </div>
                                    </td>
                                    <td>{{parcelSearchResult.result.displayName}}</td>
                                    <td>{{parcelSearchResult.result.alternateName}}</td>
                                    <td>{{parcelSearchResult.result.landTypeShortDescription}}</td>
                                    <td>{{parcelSearchResult.result.landStatus}}</td>
                                </tr>
                            }
                        </tbody>
                        <tfoot>
                            <tr>
                                <td colspan="5">{{getSelectedParcelSummary()}}</td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
            <div class="parcel-extract row">
                <div class="col-xs-12">
                    <select
                        id="coordinateSystem"
                        class="nlr-select"
                        [attr.name]="'coordinateSystem'"
                        [name]="'coordinateSystem'"
                        [disabled]="coordinateSystemDisabled()"
                        [(ngModel)]="selectedCoordinateSystem"
                        required>
                        <option
                            selected
                            hidden
                            [value]="null">
                            Select coordinate system
                        </option>
                        @for (projectedCoordinateSystem of projectedCoordinateSystemLookups; track $index) {
                            <option [ngValue]="projectedCoordinateSystem">
                                {{projectedCoordinateSystem.description}}
                            </option>
                        }
                    </select>
                    <button
                        type="button"
                        id="createExtract"
                        class="btn btn-default nlr-btn-sm"
                        [disabled]="createExtractDisabled()"
                        (click)="createExtract()">
                        Create Extract
                    </button>
                    <a
                        id="downloadExtract"
                        download
                        [attr.href]="extractDownloadUrl || undefined">
                        Download Extract
                    </a>
                    <button
                        type="button"
                        id="reset"
                        class="btn btn-default nlr-btn-sm pull-right"
                        [disabled]="resetDisabled()"
                        (click)="reset()">
                        Reset
                    </button>
                </div>
                @if (createExtractErrorMessage) {
                    <div class="col-xs-12">
                        <div class="help-block">
                            <span>Error!</span>
                            <span id="createExtractErrorMessage">{{createExtractErrorMessage}}</span>
                        </div>
                    </div>
                }
            </div>
        }
    </div>
}
<section class="footer">
    <nlr-footer></nlr-footer>
</section>
